import { ApiBase } from "../../base/_ApiBase";
import { ApiClient } from "../../base/_ApiClient";
import { BannerPositionModel } from "../../models/banners/BannerPositionModel";

export const BannerPositionApi = new class BannerApi extends ApiBase<BannerPositionModel>{
    constructor({ baseUrl }: { baseUrl: string; }) {
        super(baseUrl);
    }
    
}({ baseUrl: '/ads-position' });